export const PROFILE_DETAILS = "PROFILE_DETAILS";
